module.exports = __webpack_public_path__ + "static/img/zs_d.ead44f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zs_d.png
// module id = kWzK
// module chunks = 18